import { Col, ControlLabel, Form, FormGroup, OverlayTrigger, Panel, Popover } from 'react-bootstrap';
import YesNoUnknown from '../yes-no-unknown';

interface IProps {
    directCryoSend: boolean,
    directXmSend: boolean,
    directSerologySend: boolean,
    onBooleanChange: (name: string, value: boolean) => void
}

const popOverLanguage =
    <>
        By answering yes to this field, you agree that a kit for your donor will NOT be shipped until you provide the shipping information to the shipping vendor, or
        fill out the information in the Donor Address Tab.
    </>;

const Kits = (props: IProps) => {
    const { directXmSend, directSerologySend } = props;

    return (
        <Panel>
            <Panel.Heading>
                Select the kits that you would like shipped directly to your donor when they are ordered...
            </Panel.Heading>
            <Panel.Body>
                <Form horizontal>
                    <FormGroup>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>&nbsp; - Fresh Blood Draw Kit:</Col>
                        <Col xs={12} lg={6}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <YesNoUnknown
                                    name='directXmSend'
                                    yes={directXmSend}
                                    no={!directXmSend}
                                    onChange={props.onBooleanChange} />
                                <div style={{ paddingLeft: 20 }}>
                                    <OverlayTrigger trigger={['hover', 'click']} placement='bottom' overlay={<Popover>{popOverLanguage}</Popover>}>
                                        <span className='glyphicon glyphicon-info-sign'></span>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} lg={3} componentClass={ControlLabel}>&nbsp; - Pre-Op Serology Blood Draw Kit:</Col>
                        <Col xs={12} lg={6}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <YesNoUnknown
                                    name='directSerologySend'
                                    yes={directSerologySend}
                                    no={!directSerologySend}
                                    onChange={props.onBooleanChange} />
                                <div style={{ paddingLeft: 20 }}>
                                    <OverlayTrigger trigger={['hover', 'click']} placement='bottom' overlay={<Popover>{popOverLanguage}</Popover>}>
                                        <span className='glyphicon glyphicon-info-sign'></span>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </Col>
                    </FormGroup>
                </Form>
            </Panel.Body>
        </Panel>
    );
}

export default Kits;